import { Component, OnInit, ViewChild } from '@angular/core';
import { SummaryReportsService } from "../../services/reports/summary-reports.service";
import { ConfirmationService } from "primeng/api";
import { SharedService } from "../../shared/services/shared.service";
import { TokenStorageService } from '../../services/safeguard/token-storage.service';
import { PortalUserService } from "../../services/admin/portal-user.service";
import { BrandConfigPropertyService } from '../../services/config/brand-config-property.service';
import { IBrand } from '../../shared/interfaces/brand';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-summary-reports',
  standalone: false,
  templateUrl: './summary-reports.component.html',
  styleUrls: ['./summary-reports.component.css']
})
export class SummaryReportsComponent implements OnInit {

  openBrandSelectionDialog!: boolean;
  defaultDate: any;
  brandName!: string;
  selectedReportType!: string;
  customDatesHidden!: boolean;

  reportTypes: any[] = [];
  baseUrl!: string;
  selectedBrandCode!: string;
  selectedBrandName!: string;
  selectedDateFrom!: string;
  selectedDateTo!: string;
  maxDate: Date = new Date();
  emailAddress!: string;
  brandTimeZone: string = "";

  autoResize: boolean = true;

  constructor( 
    private datePipe: DatePipe,
    private tokenStorageService: TokenStorageService,
    private summaryReportsService: SummaryReportsService, 
    private confirmationService: ConfirmationService,
    private portalUserService: PortalUserService,
    private brandConfigPropertyService: BrandConfigPropertyService, 
    private sharedService: SharedService) { }

  ngOnInit(): void {
    
      this.reportTypes = [
        {label: "Daily", value: "REPORT_DAILY"}, {label: "Weekly", value: "REPORT_WEEKLY"}, 
        {label: "Monthly", value: "REPORT_MONTHLY"}, {label: "Custom Dates", value: "REPORT_CUSTOM"}];
      this.selectedReportType = "REPORT_DAILY";
      this.customDatesHidden = true;
      /*We can not generate summary report for current date because the section in report "Notifications by Template this Period " won't be ready. 
      This section needs data into message_summary table
       message_summary table is polulated by message_summary_load stored procedure  executed by MessageSummary Scheduler at 5: 25 PM everyday.
       This batch job picks messages till yesterday EOD, because today has not ended. 
       That means if today is 20-Aug then 19-Aug messages will be available only after 5: 25 PM on 20-Aug, but by this time regular working day has altready ended.
       So messahges of 19-Aug will be availabe on 21-Aug when user logs in for their work. 
       So we are alloing max T-2 days for selection of date.
      */
      this.selectedDateFrom = this.sharedService.getPreviousDate(1);
      this.selectedDateTo = this.sharedService.getPreviousDate(1);
      this.maxDate.setDate(this.maxDate.getDate() - 1);
     

      // Prepopulate the email address input box
      var currentUserValue = this.tokenStorageService.getCurrentUser();
      if (currentUserValue != null) {
        var userName = currentUserValue.userName;
        this.portalUserService.getUserEmailAddress(userName)
        .subscribe(result => {
            this.emailAddress = result; 
        });
      }

      this.openBrandSelectionDialog = true;
  }

  // When a brand is chosen
  chooseBrand(item: IBrand) {
    this.openBrandSelectionDialog = false;
    if (item != null) {
      this.selectedBrandCode = item.brandCode || '';
      this.selectedBrandName = " ( " + item.brandName + " )";
      this.baseUrl = item.baseUrl || '';
      // Get brand config properties to see whether there is timezone there
      this.brandTimeZone = "America/New_York";
      this.brandConfigPropertyService.getBrandConfigProperties(this.baseUrl, this.selectedBrandCode)
      .subscribe (response => {
        var properties = response.brandConfigPropertyList;

        // for (var i = 0; i < properties.length; i++) {
        //   if (properties[i].propertyName == "REPORT_TimezoneID") {
        //     this.brandTimeZone = properties[i].propertyValue;
        //   }
        // }

        if (Array.isArray(properties)) {
          for (const item of properties) {
            const { propertyName } = item ?? {};
            if (propertyName == "REPORT_TimezoneID") {
              this.brandTimeZone = item.propertyValue;
            }
          }
        }

      });
    }
  }

  // When the user opens up the dialog to select a brand 
  onChooseBrandClick(event: any) {
    this.openBrandSelectionDialog = true;
  }

  onClearClick(event: any) {
    this.selectedReportType == 'REPORT_DAILY';
    this.baseUrl = '';
    this.selectedBrandCode = '';
    this.selectedBrandName = '';
    this.selectedDateFrom = '';
    this.selectedDateTo = '';
    this.brandTimeZone = '';
  }

  // Process the Search request
  onSearchClick(event: any) {
    if (!(this.baseUrl && this.selectedBrandCode && (
          this.selectedReportType != "REPORT_CUSTOM" || (this.selectedReportType == "REPORT_CUSTOM" && this.selectedDateFrom && this.selectedDateTo)))) {
      this.confirmationService.confirm({
        message: 'Make sure to select report type, brand, and (if needed) the date interval to properly define report requirements.',
        header: 'Warning',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: "Ok",
        rejectVisible: false,
        acceptButtonStyleClass: "p-button-info wal-info  p-button-rounded",
        accept: () => {
              return;
            }
      });          
      return;
    }  

    this.summaryReportsService.runSummaryReport(
      this.selectedReportType, this.baseUrl, this.selectedBrandCode, this.selectedDateFrom, this.selectedDateTo, 
      this.emailAddress, this.brandTimeZone)
    .subscribe(results => {
      this.confirmationService.confirm({
        message: results.message,
        header: 'Processed',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: "Ok",
        rejectVisible: false,
        acceptButtonStyleClass: "p-button-info wal-info  p-button-rounded",
        accept: () => {
              return;
            }
      });          
    });
  }

  onChangeReportType(event: any) {
    if (this.selectedReportType == 'REPORT_CUSTOM') {
      this.customDatesHidden = false;
    } else {
      this.customDatesHidden = true;
    }
  }

   onDateChange(event: Date, field: 'selectedDateFrom' | 'selectedDateTo'): void {
    const formattedDate = this.datePipe.transform(event, 'yyyy-MM-dd') || '';
    if (field === 'selectedDateFrom') {
      this.selectedDateFrom = formattedDate;
  
      // Ensure selectedDateTo is not earlier than selectedDateFrom
      if (this.selectedDateTo && this.selectedDateTo < this.selectedDateFrom) {
        this.alertTheUser('Warning', 'The "Date To" cannot be earlier than "Date From".');
        this.selectedDateTo = this.selectedDateFrom; // Adjust Date
      }
    } else if (field === 'selectedDateTo') {
      this.selectedDateTo = formattedDate;
  
      // Ensure selectedDateTo is not earlier than selectedDateFrom
      if (this.selectedDateTo < this.selectedDateFrom) {
        this.alertTheUser('Warning', 'The "Date To" cannot be earlier than "Date From".');
        this.selectedDateFrom = this.selectedDateTo; // Adjust Date
      }
    }
  }

    alertTheUser(header: string, message: string) {
    this.confirmationService.confirm({
      message: message,
      header: header,
      key: 'my-generated-artifacts',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: "Ok",
      rejectVisible: false,
      acceptButtonStyleClass: "p-button-info wal-info  p-button-rounded",
      accept: () => {
         return;
       }
    });
  }

}
